var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 49 39","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"#FFF","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h49v5H0zM0 17h49v5H0zM0 34h49v5H0z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70054747","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/svgs/MenuIcon.vue
// module id = null
// module chunks = 